module.exports = __webpack_public_path__ + "img/hr-tree-04-h-leaves.19781aa0.png";